export default __webpack_public_path__ + "static/logo-ac00fc3ba56e0aca6fe922e008fa73c4.svg";